import { WithAuthorization } from "../../../../context";
import { Page } from "../../../../components/Page";
import { useTranslation } from "react-i18next";
import { Card } from "../../../../components/Card";
import * as React from "react";
import { Overview, Planning } from "./components";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useState } from "react";

function MaterialIssuesAndIndicators() {
  const { t } = useTranslation("translation", {
    keyPrefix: "materialIssuesAndIndicators"
  });

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} overflow="auto">
          <Center>
            <TabList borderBottom="none" overflow="auto">
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.overview")}</Tab>
              <Tab mb={0} _focus={{ boxShadow: "none" }}>{t("tabs.planning")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <Overview />
            </TabPanel>
            <TabPanel padding="0">
              <Planning />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(MaterialIssuesAndIndicators);